module.exports = __webpack_public_path__ + "static/16-bd38bd05876cabf334a1c9e7d3468206.jpg";